import { render } from "./McrHeader.vue?vue&type=template&id=54b75894&scoped=true"
import script from "./McrHeader.vue?vue&type=script&lang=js"
export * from "./McrHeader.vue?vue&type=script&lang=js"

import "./McrHeader.vue?vue&type=style&index=0&id=54b75894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b75894"]])

export default __exports__